module.exports = __webpack_public_path__ + "img/treatment-based-options-mobile-fr.82d75b8e.jpg";